import { VNode } from 'vue';
import Ripple from 'primevue/ripple';
import { Options, Vue } from 'vue-class-component';
import TabPanel from 'primevue/tabpanel';

@Options({
  name: 'ScrollableTabView',
  slots: {
    '': TabPanel,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tabs() {
      const tabs: any[] = [];
      this.$slots.default().forEach((child: any) => {
        if (this.isTabPanel(child)) {
          tabs.push(child);
        } else if (child.children && child.children instanceof Array) {
          child.children.forEach((nestedChild: any) => {
            if (this.isTabPanel(nestedChild)) {
              tabs.push(nestedChild);
            }
          });
        }
      });
      return tabs;
    },
  },
  watch: {
    activeIndex(newValue) {
      this.d_activeIndex = newValue;

      this.updateScrollBar(newValue);
    },
  },
  emits: ['update:activeIndex', 'tab-change', 'tab-click'],
  directives: {
    'ripple': Ripple
  }
})
export default class ScrollableTabView extends Vue {
  activeIndex!: number;
  lazy!: boolean
  scrollable!: boolean;
  d_activeIndex: number = this.activeIndex;
  backwardIsDisabled = true;
  forwardIsDisabled = false;

  tabs!: any[];
  updated() {
    this.updateInkBar();
    this.scrollable && this.updateButtonState();
  }

  mounted() {
    this.updateInkBar();
    this.scrollable && this.updateButtonState();
  }

  onTabClick(event: any, i: number) {
    if (!this.isTabDisabled(this.tabs[i]) && i !== this.d_activeIndex) {
      this.d_activeIndex = i;
      this.$emit('update:activeIndex', this.d_activeIndex);

      this.$emit('tab-change', {
        originalEvent: event,
        index: i,
      });

      this.updateScrollBar(i);
    }

    this.$emit('tab-click', {
      originalEvent: event,
      index: i,
    });
  }

  onTabKeydown(event: any, i: number) {
    if (event.which === 13) {
      this.onTabClick(event, i);
    }
  }

  updateInkBar() {
    let tabHeader = (this.$refs.nav as HTMLElement).children[this.d_activeIndex];
    (this.$refs.inkbar as HTMLElement).style.width = this.getWidth(tabHeader) + 'px';
    (this.$refs.inkbar as HTMLElement).style.left =
      this.getOffset(tabHeader).left -
      this.getOffset(this.$refs.nav).left +
      'px';
  }

  updateScrollBar(index: number) {
    let tabHeader = (this.$refs.nav as HTMLElement).children[index];
    tabHeader.scrollIntoView({ block: 'nearest' });
  }

  updateButtonState() {
    const content = this.$refs.content as HTMLElement;
    const { scrollLeft, scrollWidth } = content;
    const width = this.getWidth(content);

    this.backwardIsDisabled = scrollLeft === 0;
    this.forwardIsDisabled = Math.round(scrollLeft) === scrollWidth - width;
  }

  getKey(tab: any, i: number) {
    return tab.props && tab.props.header ? tab.props.header : i;
  }

  isTabDisabled(tab: any) {
    return tab.props && tab.props.disabled;
  }

  isTabPanel(child: any) {
    return child.type.name === 'tabpanel';
  }

  onScroll(event: any) {
    this.scrollable && this.updateButtonState();

    event.preventDefault();
  }

  getVisibleButtonWidths(): any {
    const { prevBtn, nextBtn } = this.$refs;

    return [prevBtn, nextBtn].reduce(
      (acc, el) => (el ? acc + this.getWidth(el) : acc),
      0
    );
  }

  navBackward() {
    const content = this.$refs.content as HTMLElement;
    const width = this.getWidth(content) - this.getVisibleButtonWidths();
    const pos = content.scrollLeft - width;
    
    content.scrollLeft = pos <= 0 ? 0 : pos;
  }

  navForward() {
    const content = this.$refs.content as HTMLElement;
    const width = this.getWidth(content) - this.getVisibleButtonWidths();
    const pos = content.scrollLeft + width;
    const lastPos = content.scrollWidth - width;

    content.scrollLeft = pos >= lastPos ? lastPos : pos;
  }

    getWidth(el: any) {
        let width = el.offsetWidth;
        let style = getComputedStyle(el);

        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

        return width;
    }

    getOffset(el: any) {
        var rect = el.getBoundingClientRect();

        return {
            top: rect.top + (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0),
            left: rect.left + (window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
        };
    }
}
